import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import cx from "classnames";
import CustomButton from "../CustomButton";
import CustomTextField from "../../components/CustomTextField";
import classes from "./contactSales.module.css";
import { getFormattedValue } from "../../services/utils";
import { useToast } from "../../hooks/useToast";
import CreditService from "../../services/CreditService";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";

const ContactSalesForm = props => {
  const {
    closeModal,
    salesContact,
    source = "Widget",
    openings = "",
    rootMargin = true
  } = props;
  const storedProfile = useSelector(
    state => state.userProfileReducer.payload?.data
  );

  const profilePhone = storedProfile?.phone;
  const toast = useToast();
  const [formItems, setFormItems] = useState({
    phone: "",
    companyName: "",
    noOfOpenings: "",
    source
  });
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  useEffect(() => {
    const { company = {} } = storedProfile;
    if (profilePhone) {
      setFormItems({
        phone: profilePhone,
        companyName: company?.company_name,
        noOfOpenings: "",
        source
      });
    }
    if (openings) {
      setFormItems(prevValues => ({
        ...prevValues,
        noOfOpenings: openings
      }));
    }
  }, [profilePhone]);

  function handleOnChange({ target: { name, value } }) {
    value = getFormattedValue(value);
    if (name == "phone" || name == "noOfOpenings")
      value = getFormattedValue(value, true, true);
    else {
      // Check Comany name validation
      const regex = /[^A-Za-z0-9 \-\()/]/gi;
      if (value) value = value.replace(/^\s+/g, "");
      if (value) value = value.replace(regex, "");
    }
    setFormItems(prevValues => ({ ...prevValues, [name]: value }));
  }

  async function handleSubmit() {
    const { phone, companyName, noOfOpenings } = formItems;
    // Validation check
    if (!phone || phone.length < 10 || !companyName || !noOfOpenings) {
      setError(true);
      LogService.log(CREDIT_EVENTS.SALES_POP_UP_INCOMPLETE_DETAILS_ERROR, {
        ...formItems,
        src: source
      });
      return;
    } else {
      setError(false);
    }
    LogService.log(CREDIT_EVENTS.SALES_POP_UP_SEND_CLICKED, {
      ...formItems,
      src: source
    });
    try {
      setLoading(true);
      await CreditService.SaveContactDetails(formItems);
      toast.showSuccess(
        "Thank you for showing interest, we will contact you shortly"
      );
      closeModal();
    } catch (error) {
      setLoading(false);
      toast.showError(error.message);
    }
  }

  const onEmailClick = () => {
    LogService.log(CREDIT_EVENTS.SALES_POP_UP_EMAIL_CLICKED, { src: source });
  };

  const onPhoneClick = () => {
    LogService.log(CREDIT_EVENTS.SALES_POP_UP_PHONE_CLICKED, { src: source });
  };

  const { phone, companyName, noOfOpenings } = formItems;
  const { email, workingTime, contactNumber } = salesContact;
  const disabled = isLoading;
  const errorPhone = isError && phone.length < 10;
  const errorCompany = isError && companyName.trim().length == 0;
  const errorOpening = isError && !noOfOpenings;
  return (
    <div
      className={cx(
        classes.formRoot,
        rootMargin ? classes.rootMargin : "w-full"
      )}
    >
      <img src="/hire/like.svg" alt="like" height="54" width="53" />
      <div className={classes.title}>Share details to get a callback</div>
      <div className={classes.contactform}>
        <label>Phone Number</label>
        <CustomTextField
          value={phone}
          onChange={handleOnChange}
          className={
            errorPhone
              ? cx(classes.textbox, classes.textboxError)
              : classes.textbox
          }
          placeholder="Please enter the phone number"
          name="phone"
          maxlength={10}
        />
        {errorPhone && (
          <span className={classes.error}>Please enter valid phone number</span>
        )}
        <label>Company Name</label>
        <CustomTextField
          value={companyName}
          onChange={handleOnChange}
          className={
            errorCompany
              ? cx(classes.textbox, classes.textboxError)
              : classes.textbox
          }
          placeholder="Please enter company name"
          name="companyName"
          maxlength={100}
        />
        {errorCompany && (
          <span className={classes.error}>Please enter company name</span>
        )}
        <label>No. of Openings</label>
        <CustomTextField
          value={noOfOpenings}
          onChange={handleOnChange}
          className={
            errorOpening
              ? cx(classes.textbox, classes.textboxError)
              : classes.textbox
          }
          placeholder="Please enter No. of Openings"
          name="noOfOpenings"
          maxlength={5}
        />
        {errorOpening && (
          <span className={classes.error}>Please enter number of openings</span>
        )}
        <div className={classes.buttonContainer}>
          <CustomButton
            className={classes.saveButton}
            onClick={handleSubmit}
            disabled={disabled}
          >
            Send
            <img
              src="/hire/arrow-right.svg"
              alt="left arrow"
              width="20"
              height="20"
            />
          </CustomButton>
        </div>
      </div>
      <div className={classes.footerSection}>
        <div className={classes.heading}>Want to connect now?</div>
        <div className={classes.contact}>
          Call us on
          <a
            href={`tel:${contactNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onPhoneClick}
          >
            <img src="/hire/call-blue.svg" alt="call" width="17" height="17" />
            {contactNumber}
          </a>{" "}
          or email at{" "}
          <a
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onEmailClick}
          >
            {email}
          </a>
        </div>
        {workingTime && (
          <div className={classes.workingtime}>{workingTime}</div>
        )}
      </div>
    </div>
  );
};
export default ContactSalesForm;
